/**
 * When listening for keypresses on the window, you may want to exclude
 * keypresses that belong to input elements, text areas, or elements with
 * editable content. The special case of web components relies on marking the
 * web component with the CSS class `suppress-global-key-listeners`.
 *
 * Usage will generally look like this at the top of your global key press
 * event handler:
 *
 *     if(!isFreeKeyPress(event)) return;
 *
 */
export const isFreeKeyPress = (event: KeyboardEvent) => {
    if(event.target instanceof HTMLInputElement) {
        // Some input elements can have focus, but they don't accept keyboard
        // input so it doesn't make sense to capture from them. The possible
        // exceptions would be the spacebar and tab keys which do interesting
        // things with these types.
        switch(event.target.type) {
            case 'button':
            case 'checkbox':
            case 'radio':
            case 'range':
            case 'reset':
            case 'submit':
                return true;
            default:
                return false;
        }
    } else if(event.target instanceof HTMLTextAreaElement
       || (event.target instanceof HTMLElement
           && event.target.isContentEditable)
       || (event.target instanceof HTMLElement
           && event.target.classList.contains('suppress-global-key-listeners')))
    {
        return false;
    }
    return true;
}
export default isFreeKeyPress;
